<div class="form">
  <h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
  <mat-dialog-content *ngIf="message" [formGroup]="form">
    {{ message }}
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Fechar</button>
  </mat-dialog-actions>
</div>
